import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Splash from './pages/splash';
import Onboarding from './pages/onboarding';
import Login from './pages/login';
import Home from './pages/home';
import Booking from './pages/booking';
import Map from './pages/map';
import Schedule from './pages/schedule';
import Notifications from './pages/notifications';
import ProfileComingSoon from './pages/profilecomingsoon';
import TicketPage from './pages/ticket';

const Routing = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/map" element={<Map />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/ticket" element={<TicketPage />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/profile" element={<ProfileComingSoon />} />
      </Routes>
    </BrowserRouter>
  );
}
 
export default Routing;
